import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Instagram } from "lucide-react";
import { LogoMark } from "./Logo";
import { CATEGORIES, catLabel } from "../lib/api";

export const Footer = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end end"] });
  const x = useTransform(scrollYProgress, [0, 1], ["-12%", "0%"]);
  return (
    <footer ref={ref} className="flip bg-ink text-cream overflow-hidden border-t-2 border-cream" data-testid="site-footer">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-10 pt-20 pb-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
          <div className="col-span-2 md:col-span-1">
            <LogoMark className="h-12 w-12" />
            <p className="mt-5 font-serif italic text-2xl leading-tight text-cream/90 max-w-xs">
              Fashion, culture, art and beauty. A magazine for the young and restless.
            </p>
          </div>
          <div>
            <p className="kicker text-hot mb-4">Sections</p>
            {CATEGORIES.map((c) => (
              <Link key={c} to={`/category/${c}`} className="block capitalize py-1 text-cream/80 hover:text-hot transition-colors" data-testid={`footer-link-${c}`}>
                {catLabel(c)}
              </Link>
            ))}
          </div>
          <div>
            <p className="kicker text-hot mb-4">Magazine</p>
            {["About", "Contributors", "Stockists", "Advertise"].map((l) => (
              <span key={l} className="block py-1 text-cream/80">{l}</span>
            ))}
          </div>
          <div>
            <p className="kicker text-hot mb-4">Follow</p>
            <a
              href="https://instagram.com/youthmagazine"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 py-1 text-cream/80 hover:text-hot transition-colors"
              data-testid="footer-instagram-link"
            >
              <Instagram className="h-4 w-4" /> Instagram
            </a>
          </div>
        </div>
        <motion.div style={{ x }} className="wordmark text-[20vw] leading-[0.85] pb-[0.28em] mt-16 text-cream whitespace-nowrap select-none" data-testid="footer-wordmark">
          youth<span className="text-pink">.</span>
        </motion.div>
        <div className="mt-6 flex flex-col sm:flex-row justify-between gap-2 kicker text-cream/60">
          <span>© 2026 Youth Magazine</span>
          <span>Issue 27 · Autumn</span>
        </div>
      </div>
    </footer>
  );
};
